import { OUTLOOK_SV_INTRO, OUTLOOK_SV_SLUG } from '@/content/outlookServices'
import { outlook } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The sixteenth report with a designed page of its own, and the seventh Future
  // 2030 outlook — asked for on 2026-08-28 in the same words as the Manufacturing,
  // Consumer Goods, Retail, Pharmaceutical and Banking ones (*"referans alarak
  // ilgili sayfayı birebir tıpa tıp aynısını tasarla"*) with a five-part full-page
  // capture of the live page and all six of the images it carries. See
  // `content/outlookServices.ts` and `pages/OutlookServices.tsx`.
  ...outlook(
    OUTLOOK_SV_SLUG,
    'Services',
    undefined,
    'future-2030-outlook-services-cover',
    'e25c9a10-db93-4ab7-a1f4-e16eddc3e360-Digitopia Digital Transformation Outlook Services Report.pdf',
  ),
  // The hero's single sentence, its bold tail included — the sibling entries below
  // join a `lede` to a `body` because their heroes are two blocks; this one is one,
  // so the two halves are rejoined here. `body` feeds exactly one thing either way:
  // the meta description `prerender.tsx` takes from `body[0]`.
  body: [`${OUTLOOK_SV_INTRO.body}${OUTLOOK_SV_INTRO.emphasis}.`],
  layout: 'services-outlook',
  // Its own words, its cover, its file and the six images its bands draw, so
  // `stillToCome` has nothing left to say about it. What is still open is
  // section-by-section on its page, and `outlookServicesChecks()` carries that into
  // the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 24
